import { render, staticRenderFns } from "./d-activity-author.vue?vue&type=template&id=3c042fc5&scoped=true&"
import script from "./d-activity-author.vue?vue&type=script&lang=js&"
export * from "./d-activity-author.vue?vue&type=script&lang=js&"
import style0 from "./d-activity-author.vue?vue&type=style&index=0&id=3c042fc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c042fc5",
  null
  
)

export default component.exports